// Real AdSense units — ca-pub-4587131507169333
export const AD_SLOTS = {
  display: "3595864760",
  inFeed: "3487806131",
  inArticle: "5647313035",
  banner: "3595864760",
  display2: "3595864760",
};

export const ADSENSE_CLIENT = "ca-pub-4587131507169333";
export const HAS_PLACEHOLDER_SLOTS = false;
export const PLACEHOLDER_SLOT_NAMES = [];